<template>
    <div class="d-flex">
        <v-select :id="`div_`+name"
                  v-model="model_id"
                  :filterable="false"
                  :name="`div_`+name"
                  :disabled="readonly"
                  :clearable="!readonly"
                  :options="modelOptions"
                  :reduce="option => option.id"
                  class="style-chooser flex-grow-1"
                  label="label"
                  placeholder=""
                  @open="openDropdown"
                  @search:focus="copyText"
                  @search="onSearch">
            <template slot="no-options">
                Start typing to search...
            </template>
        </v-select>
        <input :id="name" v-model="model_id" :name="name" type="hidden">
        <div class="d-flex ml-2">
            <a v-if="actionAdd" class="m-1" href=""
               @click.prevent="() => {actionShow = 'add'; $refs['actionAddIframe_'+name].contentWindow.location.href = actions.add+ '?iframe=true&origin='+origin}"
               data-toggle="modal"
               :data-target="'#actionAddModal_'+name">Add</a>
            <a v-if="actionUpdate && !onlyView" class="m-1" href=""
               @click.prevent="() => {actionShow = 'update'; $refs['actionUpdateIframe_'+name].contentWindow.location.reload();}"
               data-toggle="modal"
               :data-target="'#actionUpdateModal_'+name">Edit</a>
            <a v-if="actionView" class="m-1" href="" data-toggle="modal"
               @click.prevent="() => {actionShow = 'view'; $refs['actionViewIframe_'+name].contentWindow.location.href = actions.update.replace(':id', model_id) + '/edit?iframe=true&view=true'}"
               :data-target="'#actionViewModal_'+name">View</a>
            <a v-if="actionSearch" class="m-1" href=""
               @click.prevent="() => {actionShow = 'search'; $refs['actionSearchIframe_'+name].contentWindow.location.href = actions.search+ '?iframe=true&ajax_field_name='+name}"
               data-toggle="modal" :data-target="'#actionSearchModal_'+name">Search</a>
        </div>
        <div v-if="actionAdd" class="modal fade" :id="'actionAddModal_'+name" tabindex="-1" role="dialog"
             style="z-index: 999999;"
             :aria-labelledby="'actionAddModalLabel_'+name"
             aria-hidden="true">
            <div class="modal-dialog" :class="'modal-'+size" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" :id="'actionAddModalLabel_'+name">Add</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <iframe v-if="actionShow === 'add'" :ref="'actionAddIframe_'+name"
                                :src="actions.add+ '?iframe=true'+'&origin='+origin"
                                style="width: 100%; border: none; min-height: 400px;  "
                                :style="size === 'lg' ? 'min-height: 600px !important;' : ''"></iframe>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" @click="saveAdd" class="btn btn-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="actionUpdate" class="modal fade" :id="'actionUpdateModal_'+name" tabindex="-1" role="dialog"
             style="z-index: 999999;"
             :aria-labelledby="'actionUpdateModalLabel_'+name"
             aria-hidden="true">
            <div class="modal-dialog" :class="'modal-'+size" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" :id="'actionUpdateModalLabel_'+name">Edit</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <iframe v-if="actionShow === 'update' && model_id !== '' && model_id !== 0"
                                :ref="'actionUpdateIframe_'+name"
                                :src="actions.update.replace(':id', model_id) + '/edit?iframe=true'"
                                style="width: 100%; min-height: 400px; border: none; "
                                :style="size === 'lg' ? 'min-height: 600px !important;' : ''"></iframe>
                        <p v-else class="alert alert-warning">No record selected</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" @click="saveUpdate" class="btn btn-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="actionView" class="modal fade" :id="'actionViewModal_'+name" tabindex="-1" role="dialog"
             style="z-index: 999999;"
             :aria-labelledby="'actionViewModalLabel_'+name"
             aria-hidden="true">
            <div class="modal-dialog" :class="'modal-'+size" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" :id="'actionViewModalLabel_'+name">View</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <iframe v-if="actionShow === 'view' && model_id !== '' && model_id !== 0"
                                :ref="'actionViewIframe_'+name"
                                :src="actions.update.replace(':id', model_id) + '/edit?iframe=true&view=true'"
                                style="width: 100%; min-height: 400px; border: none; "></iframe>
                        <p v-else class="alert alert-warning">No record selected</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="actionSearch" class="modal fade" :id="'actionSearchModal_'+name" tabindex="-1" role="dialog"
             style="z-index: 999999;"
             :aria-labelledby="'actionSearchModalLabel_'+name"
             aria-hidden="true">
            <div class="modal-dialog" :class="'modal-'+size" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" :id="'actionSearchModalLabel_'+name">Search</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <iframe v-if="actionShow === 'search'" :ref="'actionSearchIframe_'+name"
                                :src="actions.search+ '?iframe=true&ajax_field_name='+name"
                                style="width: 100%; min-height: 400px; border: none; "></iframe>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import _ from 'lodash';

export default {
    name: "SelectComponent",
    components: {vSelect},
    props: {
        initialValue: {
            required: false,
            default: '',
        },
        name: {
            type: String,
            required: true
        },
        urlShow: {
            type: String,
            required: true
        },
        urlSearch: {
            type: String,
            required: true
        },
        changeUrlSite: {
            type: Boolean,
            required: false,
            default: false
        },
        other: {
            required: false,
        },
        mutation: {
            type: String,
            default: null
        },
        trigger: {
            type: Boolean,
            default: false
        },
        defaultOptions: {
            type: Array,
            default() {
                return []
            }
        },
        readonly: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'md'
        },
        actions: {
            default() {
                return {
                    "add": null,
                    "update": null,
                    "view": null,
                    "search": null,
                }
            }
        },
        autoload: false,
        origin: {
            type: String,
            default: 'root'
        },
        onlyView: {
            type: Boolean,
            default: false
        },
        exact: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            model_id: '',
            modelOptions: [],
            actionShow: null,
            localUrlShow: '',
            operator: '?'
        }
    },
    computed: {
        actionAdd() {
            return (this.actions.hasOwnProperty('add') && this.actions.add !== null)
        },
        actionUpdate() {
            return (this.actions.hasOwnProperty('update') && this.actions.update !== null)
        },
        actionView() {
            return (this.actions.hasOwnProperty('view') && this.actions.view !== null)
        },
        actionSearch() {
            return (this.actions.hasOwnProperty('search') && this.actions.search !== null)
        }
    },
    watch: {
        model_id: function (value) {
            if (this.changeUrlSite && value)
                window.location.href = window.location.href + '/site/' + value;
            if (this.trigger) {
                $('#' + this.name).trigger('selected', value, this.other);
            } else {
                this.$emit('selected', value, this.other)
            }
            if (this.mutation) {
                this.$store.commit(this.mutation, value)
            }
        }
    },
    methods: {
        getData() {
            let app = this;
            if (this.model_id !== '' && this.model_id !== 0 && this.model_id !== '0') {

                this.$loading(true);
                axios.get(this.localUrlShow)
                    .then((response) => {
                        this.modelOptions.push(response.data);
                        if (response.data.hasOwnProperty('id')) {
                            app.model_id = response.data.id
                        }
                        app.$forceUpdate();
                    })
                    .catch(error => {
                        let message = '';
                        if (_.has(error, 'response.data.friendly_message')) {

                            message = error.response.status + ' - ' + error.response.data.friendly_message;

                        } else if (_.has(error, 'response.status')) {

                            message = 'Request failed with status code ' + error.response.status;

                        } else {

                            message = 'Application failed with error: ' + error.message;
                            console.log(error);
                        }

                        showMessage('w', message);

                    })
                    .then(() => {
                        this.$loading(false);
                    });
            }
        },
        onSearch(search, loading) {
            loading(true);
            if (search.length) {

                this.search(loading, search, this);
            } else {
                loading(false);
            }
        },
        openDropdown() {
            if (this.autoload) {
                let vm = this;
                fetch(
                    vm.urlSearch + `${vm.operator}search=`
                ).then(res => {
                    res.json().then(json => (vm.modelOptions = json));
                });
            }
        },
        search: _.debounce((loading, search, vm) => {
            fetch(
                vm.urlSearch + `${vm.operator}search=${escape(search)}&exact=${vm.exact ? 1 : 0}&origin=${vm.origin}`
            ).then(res => {
                res.json().then(json => (vm.modelOptions = json));
                loading(false);
            });
        }, 350),
        saveAdd() {
            this.$refs['actionAddIframe_' + this.name].contentWindow.postMessage({
                name: this.name,
                action: "saveForm"
            }, '*');
        },
        saveUpdate() {
            this.$refs['actionUpdateIframe_' + this.name].contentWindow.postMessage(
                {
                    name: this.name,
                    action: "saveForm"
                }, '*');
        },
        selectSeach() {
            this.$refs['actionSearchIframe_' + this.name].contentWindow.postMessage(
                {
                    name: this.name,
                    action: "saveForm"
                }, '*');
        },
        copyText(search) {
            let value = $(`#div_${this.name} .vs__selected`).text().trim()
            let app = this;
            setTimeout(function () {
                $(`#div_${app.name} .vs__selected-options input`).val(value)
            }, 100)

        },
        newUrlShow(newModel) {
            const match = this.localUrlShow.match(/\d+$/);
            if (match) {
                this.localUrlShow = this.localUrlShow.replace(/\d+$/, newModel);
            } else {
                const hasSlash = newModel.toString().indexOf('/') !== -1;
                if (hasSlash) {
                    this.localUrlShow +=  newModel;

                }else{
                    this.localUrlShow += '/' + newModel;

                }

            }
            this.localUrlShow = this.localUrlShow.replace("://",":///").replaceAll('//', '/');

        }
    },
    mounted() {

        this.localUrlShow = this.urlShow;

        if (this.urlSearch.indexOf('?') > -1) {
            this.operator = '&';
        }

        if (this.initialValue !== '' && this.initialValue != null && this.initialValue != '0') {

            this.model_id = this.initialValue;
            if (this.defaultOptions.length > 0) {
                this.modelOptions = JSON.parse(JSON.stringify(this.defaultOptions))
            } else {
                this.getData();
            }
        }
        let app = this;
        window.addEventListener('message', function (e) {
            const data = e.data;
            if (data.hasOwnProperty('name') && data.name === app.name) {
                app.modelOptions = [
                    {id: data.id, label: data.label}
                ]
                app.model_id = data.id
                $('#actionSearchModal_' + app.name).modal('hide')
            }
        });
    },
}
</script>

<style>
.vs__selected {
    font-size: .8571em;
}

:root {
    /* Blue */
    --blue: #3f9ce8 !important;
    --blue-light: #C8E2F8;
    --blue-medium: #9ACBF3;
    --blue-dark: #125A96;
}

/* --== Scrollbar ==-- */

::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

::-webkit-scrollbar-thumb {
    background: var(--blue-medium);
    border-radius: 30px;
}

::-webkit-scrollbar-thumb:hover {
    background: var(--blue-dark);
}

::-webkit-scrollbar-track {
    background: white;
    border-radius: 0px;
}

</style>
